module.exports = __webpack_public_path__ + "media/images/svg/logotype-oculus-2941860fd1e5bc8ea6439f772fcacc15.svg";